<template>
  <v-card-actions class="ticket-action-dialog__footer">
    <div v-if="$slots.left" class="ticket-action-dialog__footer-left">
      <slot name="left" />
    </div>
    <v-spacer />
    <div class="ticket-action-dialog__footer-right">
      <slot />
    </div>
  </v-card-actions>
</template>

<script>
export default {
  name: "TicketActionDialogFooter",
};
</script>
